// removed by extract-text-webpack-plugin
module.exports = {"Navigation":"Navigation__Navigation__2telG","active":"Navigation__active__3hAr4","BackToIntroductionButton":"Navigation__BackToIntroductionButton__3RtsS","BackToIntroductionButtonNavLink":"Navigation__BackToIntroductionButtonNavLink__1ZIc_"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Navigation/Navigation.css
// module id = 536
// module chunks = 0